import { Switch } from "./ui/switch";
import { useAccess } from "../utilities/useAccess";
import { getViewLegacy, setViewLegacy } from "../middleware/HTTPInterceptors";

/**
 * "View Legacy" lens toggle — READ-ONLY visibility into the frozen
 * pre-June-2026 cohort. Rendered only for entitled users (CT
 * superAdmin/auditor, server-computed from the REAL user via /user-info so
 * it survives View As). Unlike UserSwitcher it has no testTools gate and
 * stays visible while impersonating — that is the point: the lens travels
 * through View As.
 */
export default function ViewLegacyToggle() {
  const { canViewLegacy } = useAccess();
  if (!canViewLegacy) return null;

  const handleToggle = (checked: boolean) => {
    setViewLegacy(checked);
    // Hard reload (View As precedent): every cached query re-derives under
    // the new lens; avoids stale react-query/useState-captured data.
    window.location.reload();
  };

  return (
    <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
      <Switch
        checked={getViewLegacy()}
        onCheckedChange={handleToggle}
        aria-label="View legacy records"
      />
      <span>View Legacy</span>
    </div>
  );
}
